import { SaveToDraftResult, useSaveSensorsToDraft } from '@/core/hooks-and-services/onboardedSensorsService'
import { OnboardPayload } from '@/core/models/types'

export const useTriggerSaveToDraft = () => {
    const { triggerSaveSensorsToDraft, isDraftLoading } = useSaveSensorsToDraft()

    const saveToDraft = async (data: OnboardPayload): Promise<SaveToDraftResult> => {
        try {
            return await triggerSaveSensorsToDraft(data.plant ?? '', data)
        } catch (err) {
            console.error('Save to draft failed', err)
            const message = (err as Error)?.message ?? 'Unknown error'
            return { success: false, errorMessage: message, queuedOffline: false }
        }
    }

    return {
        saveToDraft,
        isDraftLoading,
    }
}
